export enum PAGINATION_SIZE {
  DEFAULT = 'default',
  LARGE = 'large',
  SMALL = 'small'
}

export enum PAGINATION_ALIGN {
  DEFAULT = 'default',
  CENTER = 'center',
  RIGHT = 'right'
}

export enum PAGINATION_TYPE {
  TABLE = 'table',
  DEFAULT = 'default'
}
